import React from 'react';
import PropTypes from 'prop-types';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import AgentLookupActionButtons from '@components/table/actionButtons/AgentLookupActionButtons';
import Button from '@components/smartAdminUI/Button';

const AgentLookupTable = ({
  displayData,
  onAgentSelect,
  isModal = false,
}) => {
  const agentSelected = row => onAgentSelect(row);

  const actionsFormatter = (cell, row) => (
    <AgentLookupActionButtons
      agentSelected={agentSelected}
      currRow={row}
    />
  );

  const hdrSortClasses = (_column, sortOrder) => `sorting_${sortOrder}`;

  const columns = [
    {
      dataField: 'actions',
      text: 'Actions',
      formatter: actionsFormatter,
      headerStyle: { width: '55px' },
    },
    {
      dataField: 'MemberMlsId',
      text: 'MLS ID',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'MemberFirstName',
      text: 'First Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'MemberLastName',
      text: 'Last Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'OfficeName',
      text: 'Office Name',
      headerSortingClasses: hdrSortClasses,
      headerAttrs: { className: 'sorting' },
      sort: true,
    },
    {
      dataField: 'OfficePhone',
      text: 'Office Phone',
    },
  ];

  const defaultSorted = [{
    dataField: 'MemberMlsId',
    order: 'desc',
  }];

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <div className="btn-group" role="group">
      {
        options.map(option => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <Button
              variant={`${isSelect ? 'primary' : 'outline-primary'}`}
              key={option.text}
              onClick={() => onSizePerPageChange(option.page)}
            >
              {option.text}
            </Button>
          );
        })
      }
    </div>
  );

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      &nbsp;
      {`Showing rows ${from} to ${to} of ${size}`}
    </span>
  );

  const options = {
    firstPageText: '<<',
    hidePageListOnlyOnePage: true,
    lastPageText: '>>',
    nextPageText: '>',
    paginationTotalRenderer: customTotal,
    prePageText: '<',
    showTotal: true,
    sizePerPageList: [],
    sizePerPage: isModal ? 5 : 10,
    sizePerPageRenderer,
  };

  return (
    <BootstrapTable
      wrapperClasses="table-responsive"
      classes="dataTable"
      bordered={false}
      striped
      hover
      columns={columns}
      data={displayData}
      defaultSorted={defaultSorted}
      id="agentsTable"
      keyField="MemberMlsId"
      noDataIndication="Your search returned no results. Please try adjusting your search criteria."
      pagination={paginationFactory(options)}
    />
  );
};

AgentLookupTable.propTypes = {
  displayData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAgentSelect: PropTypes.func,
  isModal: PropTypes.bool,
};

export default AgentLookupTable;
